import {
  Checkbox,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { SectionForm } from "../../ui/form/SectionForm";
import { AppState } from "index";
import useRithmSectionSettings from "hooks/useRithmSectionSettings";
import { BaseInput } from "../tags/BaseInput";
import { ButtonGenerate } from "components/buttons/ButtonGenerate";
import { DownloadArchiveButton } from "components/buttons/DownloadArchiveButton";
import { SelectSfInput } from "./SelectSfInput";
import { TagNumberInput } from "../tags/TagNumberInput";
import { TagSelect } from "../../ui/inputs/TagSelect";
import { keys, scales } from "utils/constants/presets.const";
import { TagSetSettings, TagStr } from "types";
import { GeneratePlugin } from "components/buttons/GeneratePlugin";

export function RithmSection() {
  const state = useContext(AppState);
  const {
    handleChangeBassPreset,
    handleChangeBpm,
    handleChangeKey,
    handleChangeForm,
    handleChangeSeparated,
    handleChangeScale,
    handleChangeWithVariations,
  } = useRithmSectionSettings();
  const base_bass_presets: TagStr[] = state.bass_presets.value.slice(0, 3);

  return (
    <SectionForm header="Генерация ритм секции">
      <BaseInput name="Preset" idDisabled={false}>
        <Select
          value={state.selectedTagSetSettings.value.preset.toString() || ""}
          onChange={handleChangeBassPreset}
        >
          <MenuItem key={0} value={0}>
            Не выбран
          </MenuItem>
          {base_bass_presets.map((tag) => (
            <MenuItem key={tag.id} value={tag.id}>
              {tag.name}
            </MenuItem>
          ))}
        </Select>
      </BaseInput>

      <BaseInput name="Key" idDisabled={true}>
        <TagSelect
          tagList={keys}
          handleChangeTag={handleChangeKey}
          selectedTag={
            keys.find(
              (tag) => tag.name === state.selectedTagSetSettings.value.key
            )?.id || 0
          }
          nameForm="Key"
        />
      </BaseInput>
      <BaseInput name="Scale" idDisabled={true}>
        <TagSelect
          tagList={scales}
          handleChangeTag={handleChangeScale}
          selectedTag={
            scales.find(
              (tag) => tag.name === state.selectedTagSetSettings.value.scale
            )?.id || 0
          }
          nameForm="Scale"
        />
      </BaseInput>

      <BaseInput name="Темп" idDisabled={false}>
        <TagNumberInput
          selectedNumber={state.selectedTagSetSettings.value.bpm}
          handleChangeNumber={handleChangeBpm}
          name="bpm"
        />
        {/* <OutlinedInput value="120" endAdornment={<InputAdornment position="end">bpm</InputAdornment>}/> */}
      </BaseInput>

      <BaseInput name="Жанр" idDisabled={true}>
        <Select value="0">
          <MenuItem key={0} value={0}>
            Tech house
          </MenuItem>
        </Select>
      </BaseInput>

      <BaseInput name="Форма" idDisabled={false}>
        {/* <TagSelect
                tagList={state.formNames.value.map((name, idx) => ({id: idx, name: name}))}
                handleChangeTag={() => {}}

            /> */}
        <Select
          value={state.selectedTagSetSettings.value.form_idx.toString() || ""}
          onChange={handleChangeForm}
        >
          {state.formNames.value.map((name, idx) => (
            <MenuItem key={idx} value={idx}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </BaseInput>

        <Stack direction={'row'} gap={2}>
          <BaseInput name="" idDisabled={false}>
          <FormControlLabel
            sx={{ alignSelf: "flex-start" }}
            control={
              <Checkbox
                checked={state.with_variations.value}
                onChange={handleChangeWithVariations}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="with variations"
        />
      </BaseInput>

            <BaseInput name="" idDisabled={false}>
        <FormControlLabel
          sx={{ alignSelf: "flex-start" }}
          control={
            <Checkbox
              checked={state.is_separated.value}
              onChange={handleChangeSeparated}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          label="separated"
        />
      </BaseInput>
          </Stack>
      

      <SelectSfInput />

      <ButtonGenerate variant="bass" />
      <GeneratePlugin />

      {state.generatedNames.value.result_id !== "" &&
      state.generatedNames.value.midi_files.length > 0 ? (
        <Stack direction="column" spacing={1}>
          <DownloadArchiveButton variant="rhithm" format="midi" />
          <DownloadArchiveButton variant="rhithm" format="wav" />
        </Stack>
      ) : null}
    </SectionForm>
  );
}
